import { Component, Input} from '@angular/core';
import {
    ProfitLossFilter,
    ProfitLocationSale,
    ProfitEmployeeSale,
    ProfitSummary,
    ProfitProductSale
} from '../../shared';

@Component({
    selector: 'my-profit-index',
    template: require('./profit-index.component.pug')
})

export class ProfitIndexComponent {
    @Input() profitLossFilter: ProfitLossFilter;
    @Input() summary: ProfitSummary;
    @Input() existNumbersInProfitSummary: boolean = false;
    @Input() locationSales: Array<ProfitLocationSale>;
    @Input() productSales: Array<ProfitProductSale>;
    @Input() employeeSales: Array<ProfitEmployeeSale>;

    empty = false;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/profit-loss/profit/profit-index.component.ts